import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';
import AssessmentIcon from '@material-ui/icons/Assessment';

const maturityTab = EntityContentBlueprint.make({
  name: 'maturity',
  params: {
    path: 'maturity',
    title: 'Maturity',
    filter: (entity: Entity) => entity.kind.toLowerCase() === 'component',
    loader: () =>
      import('./components/MaturityTab').then(m => <m.MaturityTab />),
  },
});

const maturityCard = EntityCardBlueprint.make({
  name: 'maturity',
  params: {
    // Compact card: shown in the properties column of the entity overview.
    type: 'info',
    filter: (entity: Entity) => entity.kind.toLowerCase() === 'component',
    loader: () =>
      import('./components/MaturityCard').then(m => <m.MaturityCard />),
  },
});

const scorecardsPage = PageBlueprint.make({
  params: {
    path: '/scorecards',
    title: 'Scorecards',
    // Without an icon, the page gets no sidebar entry
    icon: <AssessmentIcon fontSize="inherit" />,
    loader: () =>
      import('./components/ScorecardsPage').then(m => <m.ScorecardsPage />),
  },
});

/** Maturity checks of components, from their catalog metadata (docs/scorecards.md). */
export default createFrontendPlugin({
  pluginId: 'scorecards',
  extensions: [maturityTab, maturityCard, scorecardsPage],
});
